/*
 * 新規登録 利用方法
 */
export const REQUEST_DIVISION_CANDIDATE_CLIENT_VALUE = 1;
export const REQUEST_DIVISION_CANDIDATE_PRO_VALUE = 2;
export const REQUEST_DIVISION_CANDIDATE_CLIENT = {
    cardLabel: 'クライアント企業として登録',
    id: 'client',
    label: '企業として登録する',
    name: {
        cardLabel: 'クライアント企業',
        label: '企業',
        proffitSearch: '事業会社',
        short: '企業として登録',
        veryShort: '企業',
    },
    short: '企業として登録',
    value: REQUEST_DIVISION_CANDIDATE_CLIENT_VALUE,
    veryShort: '企業',
};
export const REQUEST_DIVISION_CANDIDATE_PRO = {
    cardLabel: 'コンサルとして登録',
    id: 'professional',
    label: 'コンサルファームとして登録する',
    name: {
        cardLabel: 'コンサル',
        label: 'コンサルファーム',
        proffitSearch: 'コンサルファーム',
        short: 'コンサルとして登録',
        veryShort: 'コンサルファーム',
    },
    short: 'コンサルとして登録',
    value: REQUEST_DIVISION_CANDIDATE_PRO_VALUE,
    veryShort: 'コンサルファーム',
};
export const REQUEST_DIVISION_CANDIDATES = [
    REQUEST_DIVISION_CANDIDATE_CLIENT,
    REQUEST_DIVISION_CANDIDATE_PRO,
];
